import { TypedDefinition } from '@rehaje/core'

export class CSSStyleSheetDefinition extends TypedDefinition {
  override relationTo = 'Schema.CSSStyleSheet'
}
